import http from "../http/http"

// 关于我们
export const aboutUsInfo = (params) => {
    return http({
        url: "/websiteBrand/queryAboutUs",
        method: "post",
        data: params
    })
}